import { Heart, Anchor } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="py-12 bg-[#1A2B3D] border-t border-[#2C4A6E]" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <Anchor className="w-5 h-5 text-[#C9A96E] mx-auto mb-3" strokeWidth={1.5} />
        <p className="font-serif text-2xl text-white mb-2">Adrienne & Thomas</p>
        <p className="text-[#9BB0C4] text-sm mb-4">October 10th, 2026 &middot; Annapolis, Maryland</p>
        <div className="flex items-center justify-center gap-1 text-[#6B8299] text-xs">
          <span>{t('madeWith')}</span>
          <Heart className="w-3 h-3 fill-[#C9A96E] text-[#C9A96E]" />
        </div>
      </div>
    </footer>
  );
};
